import * as z from 'zod'

import { useCommonSchema } from './commonSchema'

export const useUpdateProfileSchema = () => {
  const { firstName, lastName, username } = useCommonSchema()

  const updateProfileSchema = z.object({
    firstName,
    lastName,
    username,
  })

  return updateProfileSchema
}

export type IUpdateProfileSchema = z.infer<
  ReturnType<typeof useUpdateProfileSchema>
>
